module.exports = __webpack_public_path__ + "img/logo_white.7845951.svg";